var React = require('react');

function BlockedQueriesIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.192 17.606a7 7 0 0 1-9.799-9.799l9.8 9.8zm1.414-1.414L7.808 6.394a7 7 0 0 1 9.799 9.799zM21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z","fill":"#fff"}));
}

BlockedQueriesIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = BlockedQueriesIcon;

BlockedQueriesIcon.default = BlockedQueriesIcon;
